import { Component, OnInit } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { FontAccessibilityService } from '../../shared/_services/font-accessibility.service';

@Component({
  selector: 'app-accessibility',
  templateUrl: './accessibility.component.html',
  styleUrls: ['./accessibility.component.scss']
})
export class AccessibilityComponent implements OnInit {

  constructor(private modalService: NgbModal,public styling: FontAccessibilityService) { }

  ngOnInit(): void {
  }

  loader = 'content';
  subject = '';
  message = '';
  show = false;

  openVerticallyCentered(content) {
    this.loader = 'content';
    this.modalService.open(content, {centered: true});
}

  // Increase font size

  initialFont(){
    this.styling.newStyle(['fs-14']);
    localStorage.setItem('accFont', 'fs-14');
      }
    incFont1() {
        this.styling.newStyle(['fs-18']);
        localStorage.setItem('accFont', 'fs-18');
      }
    incFont2(){
        this.styling.newStyle(['fs-20']);
        localStorage.setItem('accFont', 'fs-20');
      }

}
